import { render, staticRenderFns } from "./TableGestores.vue?vue&type=template&id=8f1711a4&scoped=true&"
import script from "./TableGestores.vue?vue&type=script&lang=js&"
export * from "./TableGestores.vue?vue&type=script&lang=js&"
import style0 from "./TableGestores.vue?vue&type=style&index=0&id=8f1711a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1711a4",
  null
  
)

export default component.exports